import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import "../styles/bundle.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BundleThankYou = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | pending | error

  useEffect(() => {
    document.title = "Thank You, The Disciplined Mind Bundle";
  }, []);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }

    let attempts = 0;
    let cancelled = false;

    const poll = async () => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (cancelled) return;
        if (res.data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        attempts += 1;
        if (attempts < 6) {
          setTimeout(poll, 2000);
        } else {
          setStatus("pending");
        }
      } catch (err) {
        if (!cancelled) setStatus("error");
      }
    };

    poll();
    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return (
    <div className="site-page page-bundle">
      <nav><div className="wrap"><div className="logo">disciplined<span>.me</span></div><Link to="/" className="nav-back">← Back home</Link></div></nav>

      <section className="hero">
        <div className="wrap">
          <div className="thankyou-card">
            {status === "checking" && (
              <>
                <h1 style={{ fontSize: "26px" }}>Verifying your payment…</h1>
                <p className="hero-sub" style={{ marginTop: "10px" }}>Hang tight, this only takes a moment.</p>
              </>
            )}

            {status === "paid" && (
              <>
                <div className="thankyou-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <h1 style={{ fontSize: "28px" }}>Thank you! Your bundle is ready.</h1>
                <p className="hero-sub" style={{ marginTop: "10px", marginBottom: "0" }}>
                  A confirmation has been sent to your inbox. Download your files below.
                </p>
                <div className="download-list">
                  <a href="/files/disciplined-mind-ebook.pdf" download="The-Disciplined-Mind-Ebook.pdf" className="download-btn">
                    ⬇ Download the E-Book, The Disciplined Mind
                  </a>
                  <a href="/files/disciplined-mind-workbook.pdf" download="The-Disciplined-Mind-Workbook.pdf" className="download-btn outline">
                    ⬇ Download the Workbook
                  </a>
                </div>
              </>
            )}

            {status === "pending" && (
              <>
                <h1 style={{ fontSize: "26px" }}>Almost there…</h1>
                <p className="hero-sub" style={{ marginTop: "10px" }}>
                  We're still confirming your payment with Stripe. This page will update automatically, refresh in a moment, or check back shortly. If you were charged, your files will unlock as soon as it's confirmed.
                </p>
              </>
            )}

            {status === "error" && (
              <>
                <h1 style={{ fontSize: "26px" }}>We couldn't verify this session.</h1>
                <p className="hero-sub" style={{ marginTop: "10px" }}>
                  This link looks invalid or has expired. If you completed a payment, please contact support with your receipt.
                </p>
                <Link to="/bundle" className="download-btn" style={{ marginTop: "18px", display: "inline-flex" }}>
                  ← Back to the bundle page
                </Link>
              </>
            )}
          </div>
        </div>
      </section>

      <footer>© Disciplined Me, Building the identity of someone who keeps going.</footer>
    </div>
  );
};

export default BundleThankYou;
